export const vehicleList = [
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/abarth1.png',
    name: 'Abarth',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/ac-cars.png',
    name: 'AC',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/acura.png',
    name: 'Acura',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/aixam.png',
    name: 'Aixam',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/alfa_romeo.png',
    name: 'Alfa Romeo',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/ariel.png',
    name: 'Ariel',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/10/arrinera-logo.png',
    name: 'Arrinera',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/aston_martin.png',
    name: 'Aston Martin',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/audi.png',
    name: 'Audi',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/bentley.png',
    name: 'Bentley',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/bmw.png',
    name: 'BMW',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/bugatti.png',
    name: 'Bugatti',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/buick.png',
    name: 'Buick',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/cadillac.png',
    name: 'Cadillac',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/caterham.png',
    name: 'Caterham',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/chevrolet.png',
    name: 'Chevrolet',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/chrysler.png',
    name: 'Chrysler',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/citroen.png',
    name: 'Citroën',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/corvette.png',
    name: 'Corvette',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/dacia.png',
    name: 'Dacia',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/daf.png',
    name: 'Daf',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/daihat.png',
    name: 'Daihatsu',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/dodge.png',
    name: 'Dodge',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/10/drmotor.png',
    name: 'DR Motor',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/elfin.png',
    name: 'Elfin',
  },
  {
    logo: 'data:image/jpeg;base64,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',
    name: 'EM',
  },

  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/ferrari.png',
    name: 'Ferrari',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/fiat.png',
    name: 'Fiat',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/ford.png',
    name: 'Ford',
  },
  {
    logo: 'http://backend.v-cop.go.th/vcop-streaming/access.do?m=img&p=corp%2Flogo%2F_25620708_023040Fomm-logo_resize.png',
    name: 'Fomm',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/gaz.png',
    name: 'Gaz',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/geely.png',
    name: 'Geely',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/gillet.png',
    name: 'Gillet',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/ginetta.png',
    name: 'Ginetta',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/gm.png',
    name: 'General Motors',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/gmc.png',
    name: 'GMC',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2013/10/Great-Wall.png',
    name: 'Great Wall',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/gumpert.png',
    name: 'Gumpert',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/10/hennessey.png',
    name: 'Hennessey logo',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/10/holden.png',
    name: 'Holden',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/honda.png',
    name: 'Honda',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/hummer.png',
    name: 'Hummer',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/hyundai.png',
    name: 'Hyundai',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/inf.png',
    name: 'Infiniti',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/isuzu.png',
    name: 'Isuzu',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/jagu.png',
    name: 'Jaguar',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/jeep.png',
    name: 'Jeep',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/joss.png',
    name: 'Joss',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/kia.png',
    name: 'Kia',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/koenigsegg.png',
    name: 'Koenigsegg',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/lada.png',
    name: 'Lada',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/lamb.png',
    name: 'Lamborghini',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/lancia.png',
    name: 'Lancia',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/land-rover.png',
    name: 'Land Rover',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/lexus.png',
    name: 'Lexus',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/linc.png',
    name: 'Lincoln',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/lotus.png',
    name: 'Lotus',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/11/luxgen-logo.png',
    name: 'Luxgen',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/11/mahindra.png',
    name: 'Mahindra',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/12/Maruti_Suzuki.png',
    name: 'Maruti Suzuki',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/mase.png',
    name: 'Maserati',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/maybach.png',
    name: 'Maybach',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/mazda.png',
    name: 'Mazda',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/mclaren.png',
    name: 'Mclaren',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/marchedrs.png',
    name: 'Mercedes',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/mg.png',
    name: 'MG',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/mini.png',
    name: 'Mini',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/mitub.png',
    name: 'Mitsubishi',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/morgan.png',
    name: 'Morgan Motor',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/mustang.png',
    name: 'Mustang logo',
  },
  {
    logo: 'https://e7.pngegg.com/pngimages/43/969/png-clipart-segway-pt-electric-vehicle-logo-scooter-scooter-text-scooter.png',
    name: 'Ninebot',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/nissan.png',
    name: 'Nissan',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/noble.png',
    name: 'Noble',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/opel.png',
    name: 'Opel',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/pagani.png',
    name: 'Pagani',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/panoz.png',
    name: 'Panoz',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/perodua.png',
    name: 'Perodua',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/peug.png',
    name: 'Peugeot',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/piaggio.png',
    name: 'Piaggio',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/pininfarina.png',
    name: 'Pininfarina',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/porsche.png',
    name: 'Porsche',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/proton.png',
    name: 'Proton',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/renault.png',
    name: 'Renault',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/reva.png',
    name: 'Reva',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2012/01/rimac-150x150.png',
    name: 'Rimac',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/rolls-royce.png',
    name: 'Rolls Royce',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/ruf.png',
    name: 'Ruf logo',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/saab.png',
    name: 'Saab',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/scania.png',
    name: 'Scania',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/scion.png',
    name: 'Scion',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/seat.png',
    name: 'Seat',
  },
  { logo: 'https://dealer-cdn.com/media/gevehicles/segway_stacked.png', name: 'Segway' },

  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/10/shelby.png',
    name: 'Shelby',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/skoda.png',
    name: 'Skoda',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/smart.png',
    name: 'Smart',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/spyker.png',
    name: 'Spyker',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/ssangyong.png',
    name: 'Ssangyong',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/10/ssc.png',
    name: 'SSC',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/subaru.png',
    name: 'Subaru',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/suzuki.png',
    name: 'Suzuki',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/tata.png',
    name: 'Tata',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/tatra.png',
    name: 'Tatra',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/tesla.png',
    name: 'Tesla',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/toyota.png',
    name: 'Toyota',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/1176359_187686584745478_1792749640_n.jpg',
    name: 'Tramontana',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/troller.png',
    name: 'Troller',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/tvr.png',
    name: 'TVR',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/uaz.png',
    name: 'UAZ',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/vandenbrink_design.png',
    name: 'Vandenbrink',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/vauxhall.png',
    name: 'Vauxhall',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/vector_motors.png',
    name: 'Vector Motors',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/venturi.png',
    name: 'Venturi',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/volkswagen.png',
    name: 'Volkswagen',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/volvo.png',
    name: 'Volvo',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/wiesmann.png',
    name: 'Wiesmann',
  },
  {
    logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/ae/Xiaomi_logo_%282021-%29.svg/601px-Xiaomi_logo_%282021-%29.svg.png',
    name: 'Xiaomi',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/zagato.png',
    name: 'Zagato',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/zaz.png',
    name: 'Zaz',
  },
  {
    logo: 'https://www.car-logos.org/wp-content/uploads/2011/09/zil.png',
    name: 'Zil',
  },
]
